import { fetchStatusReason } from '@/services/status-reason';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { readonly, ref } from 'vue';

export type StatusReasonStore = { main: string; secondary: string[] }[];

export const useStatusReasonStore = defineStore('statusReason', () => {
  const statusReason = ref<StatusReasonStore>([]);

  const fetchStatusReasonWithCache = async () => {
    const statusReasonFromServer = await fetchStatusReason();

    if (statusReasonFromServer.length === 0) {
      // Default
      statusReason.value = [
        {
          main: 'Problema Loja',
          secondary: [
            'Falta de produtos',
            'Loja em inventário',
            'Instituição foi até a loja e não coletou por falta de produtos',
            'Instituição foi até a loja e não coletou por falta de nota',
            'Sem nota',
            'Problema de comunicação',
            'Feriado',
            'Outros',
          ],
        },
        {
          main: 'Problema Instituição',
          secondary: [
            'Problema com carro',
            'Troca de instituição',
            'Problema de comunicação',
            'Feriado',
            'Outros',
          ],
        },
        {
          main: 'Sem Registro',
          secondary: [
            'Sem balança',
            'Registro conjunto com outra coleta',
            'Mudança no processo',
            'Outros',
          ],
        },
        {
          main: 'Reagendamento',
          secondary: [
            'Falta de produtos',
            'Loja em inventário',
            'Instituição foi até a loja e não coletou por falta de produtos',
            'Instituição foi até a loja e não coletou por falta de nota',
            'Sem nota',
            'Problema de comunicação',
            'Problema com carro',
            'Feriado',
            'Outros',
          ],
        },
      ];

      return;
    }

    statusReason.value = statusReasonFromServer.map((statusReasonDTO) => ({
      main: statusReasonDTO.title,
      secondary: statusReasonDTO.secondary_status_reasons.map((secondary) => secondary.title),
    }));
  };

  return {
    statusReason: readonly(statusReason),
    fetchStatusReasonWithCache,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useStatusReasonStore, import.meta.hot));
}
